import { inject, Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { ToastrService } from 'src/app/shared/services/toastr/toastr-service';
import { LangService } from 'src/app/shared/services/lang/lang.service';
import { ApiService } from 'src/app/shared/services/api/api.service';
import { createCalistDataEffects } from './calist-data.feature';
import { extractErrorMessage } from 'src/app/shared/util/extract-error-message';

@Injectable()
export class CalistDataEffects {
  private action$ = inject(Actions);
  private store = inject(Store);
  private apiService = inject(ApiService);
  private toastrService = inject(ToastrService);
  private langService = inject(LangService);
  private defaultErrorMessage =
    this.langService.lang.shared.fetchingErrors.calist;

  private effects = createCalistDataEffects(this.action$, this.store, {
    load: () => this.apiService.getCaList(),
    notifyError: (_, error) =>
      this.toastrService.error(
        extractErrorMessage(error) || this.defaultErrorMessage,
      ),
  });

  fail$ = this.effects.fail$;
  load$ = this.effects.load$;
  ensure$ = this.effects.ensure$;
}
